import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const KeyboardHintModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="Keyboard Reference" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-sm text-gray-500">
         <div id="pIqaDLayout">
            <div id="keyboardhint">
                <div className="text-center">
                    [ Q][ w][ e][ r][ t][ y][ u][ I][ o][ p]
                </div>
                <div className="text-center">
                    [ a][ S][ D][ ng][ gh][ H][ j][ q][ l]
                </div>
                <div className="text-center">
                    [ '][ tlh][ ch][ v][ b][ n][ m]
                </div>
            </div>
        </div>      
      </p>
    </BaseModal>
  )
}
